module.exports = __webpack_public_path__ + "img/modelzh_14.67693b03.jpg";